import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import './Footer.scss';

import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { KeyboardArrowRight } from '@material-ui/icons';

const styles = theme => ({

    footerContainer: {
        width: "100%",
        backgroundColor: "#00154A",
        backgroundSize:"cover",    
    },

    footerBar: {
        fontFamily: "Raleway, open sans",
        paddingRight: 15,
        paddingLeft: 15,
        paddingTop: 15,
        marginRight: "auto",
        marginLeft: "auto",
        maxWidth: 1170,
        height: 320,
    },    
    bottomLevel: {
        listStyle: "none",
        display: "block",
        padding: 0,
        margin: 0,
    },
    bottom1Item: {
        width: "25%",
        textAlign: "left",
        cursor: "normal",
        float: "left",
        listStyleType: "none",
        position: "relative",
        margin: 0,
        paddingRight: 15,
        paddingLeft: 15,
        display: "block",
        transition: "all 0.7s ease 0s",          

        '& a:active': {
            textDecoration: "none",
        },
    
    },
    
    bottom1ItemLabel: {
        fontWweight: 300,
        letterSpacing: "normal",
        color: "#ef2d22",
        fontSize: "24px",
        lineHeight: 1.5,
        display: "block",
        textDecoration: "none",
    },

    bottom2Item: {
        cursor: "pointer",
        display: "block",
        listStyleType: "none",
        textDecoration: "none",
        textAlign: "left",
        marginLeft: -47,

        '& a': {
            textDecoration: "none",
        },

    },

    bottom2ItemLabel:  {
        fontSize: "14px",
        lineHeight:"33px",
        color: "#aaaaaa",
        textDecoration: "none",

        '&:hover':{
            color: "#ef2d22",
            fontSize: "13px",
        },

        '&:before':{
            Contents:"\f105",

        }
    },

});

const HLAS_FOOTER = [
    {
        id: 'navigation-personal',
        children: [
            {
            id: 'navigation-TravelInsurance',
            link: "https://www.hlas.com.sg/PersonalInsurance/TravelInsurance.aspx",
            label: "Travel Insurance",
            subchildren:[]
            },
            {
                id: 'navigation-HomeContentsInsurance',
                link: "https://www.hlas.com.sg/PersonalInsurance/TravelInsurance.aspx",
                label: "Home Contents Insurance",
                subchildren:[]
            },
            {
                id: 'navigation-CarInsurance',
                link: "https://www.hlas.com.sg/PersonalInsurance/CarInsurance.aspx",
                label: "Car Insurance",
                subchildren:[]
            },
            {
                id: 'navigation-FireInsurance',
                link: "https://www.hlas.com.sg/PersonalInsurance/FireInsurance.aspx",
                label: "Fire  Insurance",
                subchildren:[]
            },
            {
                id: 'navigation-PersonalAccident',
                link: false,
                label: "Personal Accident",
                subchildren:[
                    {
                        id: 'navigation-AccidentProtect360',
                        link: "https://www.hlas.com.sg/PersonalInsurance/PersonalAccident/AccidentProtect360.aspx",
                        label: "Accident Protect360",
                    },
                    {
                        id: 'navigation-FamilyProtect360',
                        link: "https://www.hlas.com.sg/PersonalInsurance/PersonalAccident/FamilyProtect360.aspx",
                        label: "Family Protect360",
                    },
                ]
            },
            {
                id: 'navigation-MobilePhoneInsurance',
                link: "https://www.hlas.com.sg/PersonalInsurance/MobilePhoneInsurance.aspx",
                label: "MobilePhoneInsurance",
                subchildren:[]
            },
            {
                id: 'navigation-maidinsurance',
                link: "https://ww2.hlas.com.sg/personalinsurance/maidinsurance/",
                label: "Maid Insurance",
                subchildren:[]
            },
        ],
        link: false,
        label: "Personal",
        alt: "PERSONAL INSURANCE"
    },
    {
        id: 'navigation-commercial',
        children: [
            {
            id: 'navigation-PropertyInsurance',
            link: "https://www.hlas.com.sg/Commercial/PropertyInsurance.aspx",
            label: "Property Insurance",
            subchildren:[]
            },
            {
                id: 'navigation-CasualtyInsurance',
                link: "https://www.hlas.com.sg/Commercial/CasualtyInsurance.aspx",
                label: "Casualty Insurance",
                subchildren:[]
            },
            {
                id: 'navigation-EngineeringInsurance',
                link: "https://www.hlas.com.sg/Commercial/EngineeringInsurance.aspx",
                label: "Engineering Insurance",
                subchildren:[]
            },
            {
                id: 'navigation-BusinessPackages',
                link: "https://www.hlas.com.sg/Commercial/BusinessPackages.aspx",
                label: "Business Packages",
                subchildren:[]
            }
        ],
        link: false,
        label: "Commerical",
        alt: "COMMERCIAL INSURANCE"
    },
    {
        id: 'navigation-usefullinks',
        children: [
            {
            id: 'navigation-OurCorporateProfile',
            link: "https://www.hlas.com.sg/AboutUs/OurCorporateProfile.aspx",
            label: "Our Corporate Profile",
            subchildren:[]
            },
            {
                id: 'navigation-EthicsPolicy',
                link: "https://www.hlas.com.sg/AboutUs/EthicsPolicy.aspx",
                label: "Ethics Policy",
                subchildren:[]
            },
            {
                id: 'navigation-News',
                link: "https://www.hlas.com.sg/HLASPartners/Login.aspx",
                label: "News",
                subchildren:[]
            },
            {
                id: 'navigation-Careers',
                link: "https://www.hlas.com.sg/AboutUs/Careers.aspx",
                label: "Careers",
                subchildren:[]
            },
            {
                id: 'navigation-Blog',
                link: "https://ww2.hlas.com.sg/Blog/",
                label: "Blog",
                subchildren:[]
            },
            {
                id: 'navigation-AgentRecruitment',
                link: "https://www.hlas.com.sg/Agency/AgentRecruitment.aspx",
                label: "Agent Recruitment",
                subchildren:[]
            },
            {
                id: 'navigation-AgentLogin',
                link: "https://www.hlas.com.sg/HLASPartners/Login.aspx",
                label: "Agent Login",
                subchildren:[]
            }

        ],
        link: false,
        label: "Useful Links",
        alt: "Useful Links"
    },
    {
        id: 'navigation-legal',
        children: [],
        link: false,
        label: "Legal",        
        alt: "Legal"
    }
];


class Footer extends Component {

    componentDidMount() {

    }
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.footerContainer}>
                <div className={classes.footerBar}>
                    <ul className={classes.bottomLevel} >
                    {HLAS_FOOTER.map(({ id, children, link, label}) => (
                        
                            <li  className={classes.bottom1Item} key={id} >
                                {link ? <a href={link}><span className={classes.bottom1ItemLabel}>{label}</span></a> : <span className={classes.bottom1ItemLabel}>{label}</span> }
                                {children.map(({ id, link, label, subchildren}) => (
                                    <ul>
                                        <li  className={classes.bottom2Item} key={id}>
                                            {link ? <a href={link}><span className={classes.bottom2ItemLabel}><KeyboardArrowRight />{label}</span></a> : <span className={classes.bottom2ItemLabel}><KeyboardArrowRight />{label}</span> }                                  
                                        </li>
                                    </ul>
                                ))}
                            </li>
                    ))}
                    </ul>
                </div>
            </div>
            
        );
        
    }
}



Footer.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Footer);